/**
 * Durations in named units, so a conversion reads as the unit it converts to
 * rather than as arithmetic the reader has to redo: `elapsedMs / SECOND_MS`,
 * not `elapsedMs / 1000`. The suffix is the unit the value is counted in.
 */
export const SECOND_MS = 1000;
export const MINUTE_MS = 60_000;
export const HOUR_MS = 3_600_000;
export const DAY_MS = 86_400_000;
export const WEEK_MS = 7 * DAY_MS;
/** Nominal lengths, for a measure read at a glance. A calendar step goes through lib/time. */
export const MONTH_MS = 30 * DAY_MS;
export const YEAR_MS = 365 * DAY_MS;

export const MILLISECOND_US = 1000;
export const SECOND_US = 1_000_000;

export const MINUTE_S = 60;
export const HOUR_S = 3600;
export const DAY_S = 86_400;

export const HOUR_MIN = 60;

export const DAY_H = 24;
